import create, {initializeAndRegisterHooks} from 'context/create' 
import triggers, * as resolves from './triggers'

export const initialModals = {
    login: {open: false, email: '', password: ''},
    reset: {open: false, email: ''},
    register: {
        open: false,
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirmPassword: '',
    }
}

export const initialState = {
    user: JSON.parse(localStorage.getItem('user')) ?? undefined,
    modals: initialModals
}

const id = 'Auth'
const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, triggers, resolves)})
export {context as default}